import { action } from 'mobx';

import DeviceModel from 'app/stores/device/DeviceModel';
import DeviceCollection from '../device/DeviceCollection';

class InterfacesDeviceCollection extends DeviceCollection {
  fetch() {
    // For now, we want to exclude cloud devices from IC, eventually we may want to change this
    return super.fetch({ query: { filterCloud: true } });
  }

  getFilterValues(model: DeviceModel | Record<string, string>) {
    // @ts-expect-error not very good type safety here
    return ['device_name'].map((name) => model[name] || model.get(name));
  }

  get secondarySort() {
    return {
      field: 'interfaceCount',
      direction: 'desc'
    } as const;
  }

  get defaultSortState() {
    return {
      field: 'percentMatched',
      direction: 'desc'
    } as const;
  }

  @action
  updateDeviceInterfaceMatchData(deviceMatches: Record<string, object>) {
    const deviceIds = Object.keys(deviceMatches);
    for (let i = 0; i < deviceIds.length; i++) {
      const key = deviceIds[i];
      const matchInfo = deviceMatches[key];
      if (matchInfo) {
        const model = this.get(key);
        if (model) {
          model.set({ loadingInterfaceResults: false, ...matchInfo });
        }
      }
    }
  }
}

export default InterfacesDeviceCollection;
